<div class="ui-project__header">
  <div class="actions__buttons">
    <app-button
      class="share-button"
      [disabled]="!this.checkedTaskIds.length"
      [permission]="{ group: PermissionsGroups.TASKS, action: 'CHANGE_SHARE' }"
      (onClick)="shareChanges()"
      confirmButtonType="success"
      placement="bottom"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        text: WindowHelper.isMobileWidth
          ? ''
          : ('ProjectChanges.shareNChanges' | translate: { amount: this.checkedTaskIds.length }),
        prependSrc: './assets/img/ic-share.svg'
      }"
    />

    <app-button
      class="share-button"
      [disabled]="!this.checkedTaskIds.length"
      [permission]="{ group: PermissionsGroups.TASKS, action: 'CHANGE_SHARE' }"
      (onClick)="createTaskFromChanges()"
      [config]="{
        size: ButtonSize.SMALL,
        type: ButtonTypes.NEW_SECONDARY_BLUE,
        text: WindowHelper.isMobileWidth
          ? ''
          : ('ProjectChanges.createTaskFromChanges' | translate: { amount: this.checkedTaskIds.length }),
        prependSrc: './assets/img/ic-check-square.svg'
      }"
    />

    <list-search />

    <list-filters-btn-v2 class="ml-auto" [filters]="ProjectChangesFiltersComponent" />
  </div>
</div>

<div class="project-changes-list-wrapper">
  <div class="container-fluid--30 project-changes-list__content pb-2">
    <app-list
      *ngIf="inited"
      [config]="config"
      [filters]="ProjectChangesFiltersComponent"
      [emptyTemplate]="emptyTemplate"
      [searchName]="'ProjectChanges.List.search' | translate"
      [selected]="selected"
      [showToggleMenu]="showToggleMenu.bind(this)"
      #list
    />
  </div>

  <div class="sticky-footer">
    <app-summary-toggle [summary]="summary" [summaryConfig]="summaryConfig" />
  </div>
</div>

<ng-template #emptyTemplate>
  <div class="d-flex flex-column align-items-center mt-4 empty">
    <img
      draggable="false"
      src="/assets/img/empty-state-changes.svg"
      alt="{{ 'ProjectChanges.List.noRecords' | translate }}"
      class="mb-4 mt-4"
    />
    <div class="mt-2">{{ 'ProjectChanges.List.noRecords' | translate }}</div>
  </div>
</ng-template>

<changes-name-cell #changesNameCellComponent />
<changes-type-cell #changesCategoryCellComponent />
<add-days-cell #addDaysCellComponent />
<changes-settlement-cell #changesSettlementCellComponent />
<changes-price-cell #changesPriceCellComponent />
<changes-deadline-cell #changesDeadlineCellComponent />
<changes-status-cell #changesStatusCellComponent />
<changes-created-cell #changesCreatedCellComponent />
<changes-name-header-cell #changesNameHeaderCellComponent />
